<template>
  <div class="product-comparative-card">
    <h1 class="mb-3">{{ product.DES_PRODUTO }}</h1>
    <div class="table-grid">
      <div class="empty-space border-right"></div>
      <div v-for="(item, index) in labels" :key="item.icon" class="title-cell pt-1 pb-2" :class="index === labels.length - 1 ? '' : 'border-right'">
        <div class="px-3 title-container d-flex align-center">
          <mf-icon :icon="item.icon" size="18" color="cinza-l10" />
          <h2 class="ma-0">{{ item.label }}</h2>
        </div>
        <div class="inner-grid mt-2">
          <h3 class="mb-0">1º Período</h3>
          <h3 class="mb-0">2º Período</h3>
          <div class="empty-space"></div>
        </div>
      </div>

      <div class="dark-bg label border-right">
        <span>Clube</span>
      </div>
      <div v-for="(item, index) in clubData" :key="item.id" :class="index === clubData.length - 1 ? '' : 'border-right'" class="inner-grid dark-bg">
        <span>{{ item.value1 }}</span>
        <span>{{ item.value2 }}</span>
        <mf-stonks variant="percentage" :percentage="item.percentage" />
      </div>

      <div class="label border-right">
        <span>Total</span>
      </div>
      <div v-for="(item, index) in totalData" :key="item.id" :class="index === totalData.length - 1 ? '' : 'border-right'" class="inner-grid">
        <span>{{ item.value1 }}</span>
        <span>{{ item.value2 }}</span>
        <mf-stonks variant="percentage" :percentage="item.percentage" />
      </div>
    </div>
  </div>
</template>

<script>
import MfStonks from '@/modules/maria/produtos-impulsionadores/views/components/Step1/MfStonks.vue'
import { localeString } from '@/config/helpers.js'
export default {
  name: 'ProductComparativeCard',
  components: { MfStonks },
  props: {
    product: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    clubData() {
      return [
        {
          id: '1',
          value1: this.product.VAL_FATURAMENTO_CLUBE_1 ? 'R$' + localeString(this.product.VAL_FATURAMENTO_CLUBE_1, 2) : '-',
          value2: this.product.VAL_FATURAMENTO_CLUBE_2 ? 'R$' + localeString(this.product.VAL_FATURAMENTO_CLUBE_2, 2) : '-',
          percentage: this.product.VAL_FATURAMENTO_CLUBE_PCT_2,
        },
        {
          id: '2',
          value1: this.product.VAL_QUANTIDADE_CLUBE_1 ? localeString(this.product.VAL_QUANTIDADE_CLUBE_1, 0) : '-',
          value2: this.product.VAL_QUANTIDADE_CLUBE_2 ? localeString(this.product.VAL_QUANTIDADE_CLUBE_2, 0) : '-',
          percentage: this.product.VAL_QUANTIDADE_CLUBE_PCT_2,
        },
        {
          id: '3',
          value1: this.product.NUM_CUPONS_CLUBE_1 ? localeString(this.product.NUM_CUPONS_CLUBE_1, 0) : '-',
          value2: this.product.NUM_CUPONS_CLUBE_2 ? localeString(this.product.NUM_CUPONS_CLUBE_2, 0) : '-',
          percentage: this.product.NUM_CUPONS_CLUBE_PCT_2,
        },
        {
          id: '4',
          value1: this.product.NUM_CLIENTES_CLUBE_1 ? localeString(this.product.NUM_CLIENTES_CLUBE_1, 0) : '-',
          value2: this.product.NUM_CLIENTES_CLUBE_2 ? localeString(this.product.NUM_CLIENTES_CLUBE_2, 0) : '-',
          percentage: this.product.NUM_CLIENTES_CLUBE_PCT_2,
        },
      ]
    },
    totalData() {
      return [
        {
          id: '5',
          value1: this.product.VAL_FATURAMENTO_TOTAL_1 ? 'R$' + localeString(this.product.VAL_FATURAMENTO_TOTAL_1, 2) : '-',
          value2: this.product.VAL_FATURAMENTO_TOTAL_2 ? 'R$' + localeString(this.product.VAL_FATURAMENTO_TOTAL_2, 2) : '-',
          percentage: this.product.VAL_FATURAMENTO_TOTAL_PCT_2,
        },
        {
          id: '6',
          value1: this.product.VAL_QUANTIDADE_TOTAL_1 ? localeString(this.product.VAL_QUANTIDADE_TOTAL_1, 0) : '-',
          value2: this.product.VAL_QUANTIDADE_TOTAL_2 ? localeString(this.product.VAL_QUANTIDADE_TOTAL_2, 0) : '-',
          percentage: this.product.VAL_QUANTIDADE_TOTAL_PCT_2,
        },
        {
          id: '7',
          value1: this.product.NUM_CUPONS_TOTAL_1 ? localeString(this.product.NUM_CUPONS_TOTAL_1, 0) : '-',
          value2: this.product.NUM_CUPONS_TOTAL_2 ? localeString(this.product.NUM_CUPONS_TOTAL_2, 0) : '-',
          percentage: this.product.NUM_CUPONS_TOTAL_PCT_2,
        },
        {
          id: '8',
          value1: this.product.NUM_CLIENTES_TOTAL_EST_1 ? localeString(this.product.NUM_CLIENTES_TOTAL_EST_1, 0) : '-',
          value2: this.product.NUM_CLIENTES_TOTAL_EST_2 ? localeString(this.product.NUM_CLIENTES_TOTAL_EST_2, 0) : '-',
          percentage: this.product.NUM_CLIENTES_TOTAL_EST_PCT_2,
        },
      ]
    },
    labels() {
      return [
        {
          label: 'Faturamento',
          icon: 'payments',
        },
        {
          label: 'Quantidade de itens',
          icon: 'sell',
        },
        {
          label: 'Número de cupons',
          icon: 'shopping_cart',
        },
        {
          label: 'Clientes',
          icon: 'group',
        },
      ]
    },
  },
}
</script>

<style lang="scss" scoped>
h1 {
  font-weight: 700;
  color: $cinza-d10;
  font-size: 18px;
}
.table-grid {
  width: 100%;
  display: grid;
  grid-template-columns: 64px 355px 1fr 1fr 1fr;
  grid-template-rows: 56px 36px 36px;
}

.dark-bg {
  background-color: $cinza-l90;
  border-bottom: 1px solid #e8e8e9;
  border-top: 1px solid $cinza-d10;
}

.label {
  padding: 8px;
  span {
    font-weight: 700;
    color: $cinza-d10;
    font-weight: 14px;
  }
}

.inner-grid {
  display: grid;
  grid-template-columns: 1fr 1fr 100px;
  gap: 10px;
  align-items: center;
  padding: 0 12px;
  span {
    color: $cinza-d10;
    font-size: 14px;
    font-weight: 400;
  }
  h3 {
    color: $cinza-d10;
    font-size: 12px;
    font-weight: 600;
  }
}

.border-right {
  border-right: 1px solid $cinza-d10;
}

.title-cell {
  .title-container {
    gap: 6px;
    h2 {
      font-size: 14px;
      font-weight: 600;
      color: $cinza-l10;
    }
  }
}

.product-comparative-card {
  padding-bottom: 80px;
}
</style>
